import React from 'react';

interface ModalCloseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClose: () => void;
  size?: number;
}

export const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
  onClose,
  size = 14,
  className = '',
  ...buttonProps
}) => {
  return (
    <button
      type="button"
      onClick={onClose}
      aria-label="Close"
      className={`absolute top-1.5 right-1.5 text-white/80 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70 z-10 ${className}`}
      {...buttonProps}
    >
      <span
        className="block font-semibold leading-none"
        style={{ fontSize: size }}
      >
        ×
      </span>
    </button>
  );
};
